// This file contains all the config for the natural language interface

module.exports = 
{
  "operators": [
    "(([personConcept]) [earn|earns] ((<count> ([dollarConcept])) [every] ([week])))",
    "(([personConcept]) [earn] ([query|what]))",
    "(([personConcept]) [worked] (<count> ([week|weeks])))",
  ],
  "bridges": [
    {"id": "week", "level": 0, "bridge": "{ ...next(operator) }", "uuid": "4"},
    {"id": "dollarConcept", "level": 0, "bridge": "{ ...next(operator) }", "uuid": "4"},
    {"id": "personConcept", "level": 0, "bridge": "{ ...next(operator) }", "uuid": "4"},
    {"id": "every", "level": 0, "bridge": "{ marker: 'dollarConcept', units: 'dollars', amount: before.value, duration: 'week' }", "uuid": "4"},
    {"id": "earn", "level": 0, "bridge": "{ marker: 'earn', units: 'dollars', amount: after.amount, who: before.id, period: after.duration }", "uuid": "4"},
    {"id": "worked", "level": 0, "bridge": "{ marker: 'worked', who: before.id, duration: after.number, units: after.marker }", "uuid": "4"},
  ],
  "hierarchy": [
  ],
  "priorities": [
    {"context": [["query", 0], ["earn", 0], ["worked", 0], ["every", 0]], "choose": [0]},
    {"context": [["count", 0], ["earn", 0], ["worked", 0], ["query", 0]], "choose": [0]},
    {"context": [["worked", 0], ["earn", 0], ["every", 0]], "choose": [0]},
  ],
  "associations": {
    "negative": [],
    "positive": [],
  },
  "words": {
    "literals": {"dollars": [{"id": "dollarConcept", "initial": {"language": "english"}, "uuid": "4"}], "joe": [{"id": "personConcept", "initial": {"id": "joe"}, "uuid": "4"}], "per": [{"id": "every", "uuid": "4"}], "sally": [{"id": "personConcept", "initial": {"id": "sally"}, "uuid": "4"}], "week": [{"id": "week", "initial": {"language": "english"}, "uuid": "4"}]},
    "patterns": [],
    "hierarchy": [],
  },
  "floaters": [
    "isQuery",
  ],
  "implicits": [
    "language",
  ],
  "flatten": [
    "conj",
  ],
  "utterances": [
    "joe earns 10 dollars every week sally earns 25 dollars per week sally worked 10 weeks joe worked 15 weeks joe earns what sally earns what",
  ],
  "generators": [
    [({context}) => context.marker == 'week' && context.duration == 1, async ({g, gs, context}) => `${context.duration} week`],
    [({context}) => context.marker == 'week' && context.duration > 1, async ({g, gs, context}) => `${context.duration} weeks`],
    [({context}) => context.marker == 'earn', async ({g, gs, context}) => `${await g(context.who)} earns ${await g(context.amount)} ${await g(context.units)} per ${context.period}`],
    [({context}) => context.marker == 'worked', async ({g, gs, context}) => `${await g(context.who)} worked ${ await g({ marker: context.units, duration: context.duration}) }`],
    [({context}) => context.marker == 'response', async ({g, gs, context}) => `${context.who} earned ${context.earnings} ${context.units}`],
  ],
  "semantics": [
    [({objects, context}) => context.marker == 'earn' && context.isQuery, ({objects, context}) => { 
      context.marker = 'response'; 
      var employee_record = objects.employees.find( (er) => er.name == context.who )
      let totalIncome = 0
      objects.workingTime.forEach( (wt) => {
        if (wt.name == context.who) {
          totalIncome += employee_record.earnings_per_period * wt.number_of_time_units
        }
      });
      context.earnings = totalIncome
     }],
    [({objects, context}) => context.marker == 'earn', ({objects, context}) => { 
      if (! objects.employees ) {
        objects.employees = []
      }
      objects.employees.push({ name: context.who, earnings_per_period: context.amount, period: context.period, units: 'dollars' })
     }],
    [({objects, context}) => context.marker == 'worked', ({objects, context}) => { 
      if (! objects.workingTime ) {
        objects.workingTime = []
      }
      objects.workingTime.push({ name: context.who, number_of_time_units: context.duration, time_units: context.units })
     }],
    [({objects, context}) => context.pullFromContext
, ({objects, context}) => { 
    const object = objects.mentioned[0]
    objects.mentioned.shift()
    Object.assign(context, object)
    delete context.pullFromContext
     }],
  ],
};